import { NgModule, ErrorHandler } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { IonicApp, IonicModule, IonicErrorHandler } from 'ionic-angular';
import { MyApp } from './app.component';

import { HomePage } from '../pages/home/home';
import { MemberPage } from '../pages/member/member';
import { BasicPage } from '../pages/basic/basic';
import { ProcessPage } from '../pages/process/process';
import { UrlparsePageModule } from '../pages/urlparse/urlparse.module';

import { SplashScreen } from '@ionic-native/splash-screen';
import { NativePageTransitions } from '@ionic-native/native-page-transitions';
import { Network } from '@ionic-native/network';
import { SQLite } from '@ionic-native/sqlite';
import { InAppBrowser } from '@ionic-native/in-app-browser';

import { DataProvider } from '../providers/data/data';
import { CardProvider } from '../providers/data/data';
import { PageProvider } from '../providers/data/data';
import { RestProvider } from '../providers/rest/rest';

@NgModule({
  declarations: [
    MyApp,
    HomePage,
    MemberPage,
    ProcessPage,
    BasicPage,
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    IonicModule.forRoot(MyApp, {
      scrollAssist: true,
      autoFocusAssist: true
    }),
    UrlparsePageModule,
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    HomePage,
    MemberPage,
    ProcessPage,
    BasicPage,
  ],
  providers: [
    SplashScreen,
    NativePageTransitions,
    Network,
    SQLite,
    DataProvider,
    CardProvider,
    PageProvider,
    RestProvider,
    InAppBrowser,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts